export const SET_LOADING = 'APP_SET_LOADING';
export const UNSET_LOADING = 'APP_UNSET_LOADING';
